import * as React from "react";
import { cn } from "@/shared/lib/utils";

interface ITransparentButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode,
    textColor?: 'black' | 'white' 
}

const TransparentButton = React.forwardRef<HTMLButtonElement, ITransparentButtonProps>(
    ({ children, textColor, className, ...props }, ref) => {

        const colorVariants = {
            black: "bg-white-50 hover:bg-white-80 active:bg-white-20 text-black",
            white: "bg-white-20 hover:bg-white-50 active:bg-white-10 text-white"
        };

        return (
            <button
                ref={ref}
                className={cn(
                    "shadow-glass border-[0.5px] border-white-50 !leading-none rounded-full font-manrope text-[16px] transition-all ease-linear duration-200",
                    "px-6 py-3 flex items-center justify-center cursor-pointer",
                    textColor && colorVariants[textColor],
                    className
                )}
                {...props}
            >
                {children}
            </button>
        );
    }
);

TransparentButton.displayName = "TransparentButton";

export default TransparentButton;